export const SUB_TABLE_BACKGROUND = "#e9ecef"
